import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MessageDto } from 'src/app/shared/dto/MessageDto';
import { IChatMessage } from 'src/app/shared/interfaces/chatMessage';
import { IVisitLink } from 'src/app/shared/interfaces/visitLink';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';
import { ChatService } from 'src/app/shared/services/chat.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.css'
})
export class ChatComponent implements OnInit {

  visitId: number;
  chatModel: IChatMessage[];
  file: any;
  fileName: string;
  visit: IVisitLink;

  @ViewChild('modal') modal!: ModalComponent;
  @ViewChild('section') section!: ElementRef;

  constructor(public chatService: ChatService, public apiService: ApiService, private route: ActivatedRoute, private messageService: MessageService) {}

  ngOnInit(): void {

    this.visitId = this.route.snapshot.params.visitId;

    this.getVisitLink();

    this.getChatHistory();

    this.chatService.retrieveMappedObject().subscribe( (receivedObj: MessageDto) => { this.addToInbox(receivedObj);});  // calls the service method to get the new messages sent
                         
    this.reciveMessage();

    this.scrollToEnd();
  }


  ngAfterViewChecked() {
    this.scrollToEnd();
  }

  scrollToEnd() {
    this.section.nativeElement.scrollTop = this.section.nativeElement.scrollHeight;

    // setTimeout(() => {
    //   this.section.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    // }, 100); 
  }

  getVisitLink() {
    this.apiService.apiCall('get', '/api/PatientsVisitActive/'+ this.visitId +'/GetVisitInfoForConsultantById').subscribe((res: any) => {
      console.log(res);
      
      this.visit = res.body.model
    })
  }

  msgDto: MessageDto = new MessageDto();
  msgInboxArray: MessageDto[] = [];

  send(): void {
    if(this.msgDto) {
      if(this.msgDto.msgText.length == 0 ){
        window.alert("Both fields are required.");
        return;
      } else {
        let time = new Date().getTime().toString();

        this.chatService.sendMessage(this.visitId, this.msgDto.msgText, time);
        this.chatService.recieveRoom();
        this.chatService.userMessageHistory.push({ text: this.msgDto.msgText, date: time, meIsSender: true, type: 1 })
        this.msgDto.msgText = '';
        // window.alert("Success.");
        // this.chatService.broadcastMessage(this.msgDto);                   // Send the message via a service
      }
    }
  }

  fileChangeEvent(event: any): void {
    
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      
      this.file = input.files[0];
      this.fileName = this.file.name; 
      this.modal.open();
    }
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event1) => { // called once readAsDataURL is completed      
        // this.newCategory.imgFile = this.url;
      }
    }
  }

  attachFile() {

    var file = new FormData();
    file.append('File', this.file);
    file.append('VisitId', this.visitId.toString());
    
    this.apiService.callFormDataApi('/api/Conversations/AddConversationFile', file).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'فایل با موفقیت بارگزاری شد.' });
        this.modal.close();
        this.chatService.userMessageHistory.push(res.body.model);
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  getFileExtension(fileName: string): string | null {
    return fileName.includes('.') ? fileName.split('.').pop() : null;
  }

  getChatHistory() {
    this.apiService.apiCall('get', '/api/Conversations/'+ this.visitId +'/GetConversationHistoryByVisitId').subscribe((res: any) => {
      console.log(res);
      
      this.chatService.userMessageHistory = res.body.model;
    })
  }

  reciveMessage() {
    this.chatService.recieveMessages();

    // this.chatService.userMessageHistory.push(this.chatService.chatList);

  }

  addToInbox(obj: MessageDto) {
    let newObj = new MessageDto();
    newObj.user = obj.user;
    newObj.msgText = obj.msgText;
    this.msgInboxArray.push(newObj);

  }
  
}
